module.exports = __webpack_public_path__ + "img/background.d4aa7691.png";